module.exports = __webpack_public_path__ + "img/bg.52b889d4.png";